import type { EnvironmentUtils } from '@change-corgi/core/environment';
import type { ErrorReporter } from '@change-corgi/core/errorReporter/common';
import type { GqlClient } from '@change-corgi/core/gql';
import { createGqlClient as _createGqlClient } from '@change-corgi/core/gql';

import webappInfo from 'src/webappInfo';

import { wrapFetchForPerimeterX } from './shared/perimeterX';

type Options = Readonly<{
	errorReporter: ErrorReporter;
	environment: EnvironmentUtils;
}>;

export function createGqlClient({ errorReporter, environment }: Options): GqlClient {
	return _createGqlClient({
		uri: '/api-proxy/graphql',
		fetch: environment.getEnvironment() === 'production' ? undefined : wrapFetchForPerimeterX(),
		webappInfo,
		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		reportError: errorReporter.report.bind(errorReporter),
		reportNetworkError: errorReporter.createSampledReporter(0.01),
		headers: {
			accept: 'application/json',
			// eslint-disable-next-line @typescript-eslint/naming-convention
			'x-requested-with': `corgi-front-end-browser:${webappInfo.version}`,
		},
		addOperationNamesToUri: true,
	});
}
